export const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'strong',
    'em',
    's',
    'span',
    'ul',
    'ol',
    'li',
    'a'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'data-emoji']
};
